import React from 'react';
import MUIDataTable from 'mui-datatables';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { deltaPoints, deltaDir } from '../helpers';

const useStyles = makeStyles((theme) => ({
	barWrap: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 },
	bar: { width: 56, height: 5, borderRadius: 3 },
	barYellow: {
		backgroundColor: 'rgba(245,196,0,0.15)',
		'& .MuiLinearProgress-bar': { backgroundColor: '#F5C400' },
	},
	barBlue: {
		backgroundColor: 'rgba(77,138,255,0.15)',
		'& .MuiLinearProgress-bar': { backgroundColor: '#4D8AFF' },
	},
	up: { color: theme.palette.success.main, fontWeight: 600 },
	down: { color: theme.palette.error.main, fontWeight: 600 },
	flat: { color: theme.palette.text.disabled },
	rightHead: {
		textAlign: 'right',
		'& [role="button"]': { justifyContent: 'flex-end' },
	},
}));

export default function SummaryTable({ rows, nameLabel, countCols, rateLabel, vsLabel, barVariant }) {
	const classes = useStyles();
	const barCls = barVariant === 'coverage' ? classes.barYellow : classes.barBlue;

	const columns = [
		{ name: 'name', label: nameLabel, options: { sort: true } },
		...countCols.map((c) => ({
			name: c.name,
			label: c.label,
			options: {
				sort: true,
				setCellProps: () => ({ align: 'right' }),
				setCellHeaderProps: () => ({ className: classes.rightHead }),
			},
		})),
		{
			name: 'rate',
			label: rateLabel,
			options: {
				sort: true,
				setCellProps: () => ({ align: 'right' }),
				setCellHeaderProps: () => ({ className: classes.rightHead }),
				customBodyRender: (v) => {
					if (v === null || v === undefined) return '—';
					return (
						<div className={classes.barWrap}>
							<LinearProgress
								variant="determinate"
								value={Math.min(100, v)}
								className={`${classes.bar} ${barCls}`}
							/>
							<span>{v}%</span>
						</div>
					);
				},
			},
		},
		{
			name: 'prev_rate',
			label: vsLabel,
			options: {
				sort: false,
				setCellProps: () => ({ align: 'right' }),
				setCellHeaderProps: () => ({ className: classes.rightHead }),
				customBodyRender: (value, tableMeta) => {
					const rate = tableMeta.rowData[countCols.length + 1];
					const d = deltaPoints(rate, value);
					if (d === null) return '—';
					return <span className={classes[deltaDir(d)]}>{(d > 0 ? '+' : '') + d}%</span>;
				},
			},
		},
	];

	const options = {
		selectableRows: 'none',
		responsive: 'standard',
		download: false,
		print: false,
		filter: false,
		search: false,
		viewColumns: false,
		rowsPerPage: 20,
		rowsPerPageOptions: [20, 50, 100],
		elevation: 0,
	};

	return <MUIDataTable data={rows} columns={columns} options={options} />;
}
